module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobileLgWrap_he"
  }, [_c('div', {
    staticClass: "loginMain_he"
  }, [_c('form', [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "placeholder": "请输入姓名",
      "type": "text",
      "name": "mobile",
      "clearable": "",
      "label-align": "left"
    },
    on: {
      "input": _vm.changColor
    },
    model: {
      value: (_vm.realName),
      callback: function($$v) {
        _vm.realName = $$v
      },
      expression: "realName"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bd_he"
  }, [_c('van-field', {
    attrs: {
      "placeholder": "请输入身份证号码",
      "type": "text",
      "name": "identity",
      "clearable": "",
      "label-align": "left"
    },
    model: {
      value: (_vm.idCard),
      callback: function($$v) {
        _vm.idCard = $$v
      },
      expression: "idCard"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.phoneNum > 0 ? 'onLoginbtn' : ' mobileLoginBtn_he',
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("下一步")])])])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6c7e9a70"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/MobileAuthenticationSecond.vue
// module id = 1162
// module chunks = 41